import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import axios from "axios";
import { Endpoints } from "../../Global/Endpoints";
import { toast } from "react-toastify";

const ConsultationRating = () => { 
  const { t } = useTranslation();
  const navigate = useNavigate();
  const email = useSelector((state) => state.email.email);
  const token = localStorage.getItem("AccessToken");

  const [ratings, setRatings] = useState({
    q1: 0,
    q2: 0,
    q3: 0,
    q4: 0
  });

  const handleRating = (questionId, value) => {
    setRatings(prev => ({ ...prev, [questionId]: value }));
  };

  const handleBackClick = () => {
    navigate("/home");
  };

  const saveRating = async () => {

    const payload = {
      SupportProvided: ratings.q1,
      RecentExperience: ratings.q2,
      ShareJourney: ratings.q3,
      RecommendWIN: ratings.q4,
      Email: email
    };

    try {
      const response = await axios.post(
        Endpoints.SaveConsultationRating,
        `_Params=${encodeURIComponent(JSON.stringify(payload))}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data?.result === 1) {
        toast.success(t("Rating saved successfully!"));
        setTimeout(() => {
          navigate("/home");
        }, 2000);
      } else {
        toast.error("Failed to save rating");
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("An error occurred while saving your feedback.");
    }
  };

  const StarRating = ({ questionId, currentRating }) => {
    return (
      <div className="star-container">
        {[1, 2, 3, 4, 5].map((star) => (
          <i
            key={star}
            className={`bi ${star <= currentRating ? 'bi-star-fill' : 'bi-star'}`}
            style={{ 
              color: star <= currentRating ? '#FFC101' : '#E0E0E0',
              fontSize: '2rem',
              transition: 'color 0.2s ease-in-out'
            }}
            onClick={() => handleRating(questionId, star)}
          ></i>
        ))}
      </div>
    );
  };

  return (
    <div className="col-md-12">
      <div className="row">
        <div className="col-md-6 upcoming-provider-left-wrapper mb-4">
          <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
            <button className="win-back-btn" onClick={handleBackClick}>
              <span><i className='bi bi-chevron-left'></i>{t('Back')}</span>
            </button>
            <h2 className="page-heading">{t('ratingconsult')}</h2>
          </div>
          <p className="mt-3 px-2">Thank you for taking a moment to share your feedback. Your responses help us understand what's working well and where we can continue to improve.</p>
          <p className="px-2">Please rate each question using the 5-star scale, where 1 star = poor and 5 stars = <strong>excellent</strong></p>
        </div>

        <div className="rating-wrapper">
          <div className="col-md-6 col-sm-6 px-4">
          <div className="consult-rating mb-4">
            <p className="rating-title">How satisfied were you with the support provided by your WIN Advocate?</p>
            <StarRating questionId="q1" currentRating={ratings.q1} />
          </div>
          <div className="consult-rating mb-4">
            <p className="rating-title">Overall, how would you rate your recent experience with WIN?</p>
            <StarRating questionId="q2" currentRating={ratings.q2} />
          </div>
        </div>

        <div className="col-md-6 col-sm-6 px-4">
          <div className="consult-rating mb-4">
            <p className="rating-title">Would you be open to sharing your WIN journey or success story to help support or inspire others?</p>
            <StarRating questionId="q3" currentRating={ratings.q3} />
          </div>
          <div className="consult-rating mb-4">
            <p className="rating-title">How likely are you recommend WIN to a friend, family member or colleague?</p>
            <StarRating questionId="q4" currentRating={ratings.q4} />
          </div>
        </div>
        </div>

        <div className="submit-wrapper">
          <button 
            className="submit-rating mb-5" 
            onClick={saveRating}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsultationRating;